import { render } from "./AModal.vue?vue&type=template&id=4ac16742"
import script from "./AModal.vue?vue&type=script&lang=js"
export * from "./AModal.vue?vue&type=script&lang=js"

import "./AModal.vue?vue&type=style&index=0&id=4ac16742&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__